import axios from "axios";

export const linkImage = 'https://api.ecolinke.com/'
// export const linkImage = 'http://127.0.0.1:8000/'
// export const linkImage = 'http://192.168.100.183:8001/'

export const linkAPI = 'https://api.ecolinke.com'
// export const linkAPI = 'http://127.0.0.1:8000'
// export const linkAPI = 'http://192.168.100.183:8001'

const axiosClient = axios.create({
  baseURL: "https://api.ecolinke.com/",
  // baseURL: "http://127.0.0.1:8000/",
  // baseURL: "http://192.168.100.183:8001/",
});

// ── Request interceptor: attach Bearer token ─────────────────────────────────
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("ACCESS_TOKEN");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ── Response interceptor: handle 401 with automatic token refresh ─────────────
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      const refreshToken = localStorage.getItem("REFRESH_TOKEN");

      // No refresh token available → logout immediately
      if (!refreshToken) {
        localStorage.removeItem("ACCESS_TOKEN");
        localStorage.removeItem("REFRESH_TOKEN");
        localStorage.removeItem("role");
        localStorage.removeItem("CURRENT_BUSINESS");
        window.location.href = "/login";
        return Promise.reject(error);
      }

      if (isRefreshing) {
        // Queue calls while a refresh is in progress
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return axiosClient(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const response = await axios.post(`${axiosClient.defaults.baseURL}token/refresh/`, {
          refresh: refreshToken,
        });

        const newAccessToken = response.data.access;
        localStorage.setItem("ACCESS_TOKEN", newAccessToken);
        if (response.data.refresh) {
          localStorage.setItem("REFRESH_TOKEN", response.data.refresh);
        }

        axiosClient.defaults.headers["Authorization"] = `Bearer ${newAccessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        processQueue(null, newAccessToken);
        return axiosClient(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        // Refresh failed → force logout
        localStorage.removeItem("ACCESS_TOKEN");
        localStorage.removeItem("REFRESH_TOKEN");
        localStorage.removeItem("role");
        localStorage.removeItem("CURRENT_BUSINESS");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
